import React, { useEffect, Suspense } from "react";
import { Routes, Route, useNavigate, Outlet } from "react-router-dom";
import Layout from "../Layout";
import Home from "../Screens/Home";
import Login from "../Screens/Login";
import Register from "../Screens/Register";
import Welcome from "../Screens/Welcome";
import Verify from "../Screens/Verify";
import PrivateRoute from "../components/common/PrivetRoute";
import AdminPrivateRoute from "../components/common/AdminPrivateRoute";
import { useDispatch } from "react-redux";
import { clearClientData } from "../Redux/Reducer/ClientDataReducer";
import { clearUserDetails } from "../Redux/Reducer/UserDetailsReducer";
import Signout from "../Screens/Sisense(SSO)/signout";
import NotFoundPage from "../Screens/NotFound";
const QuestionnaireLayout = React.lazy(() => import("../RxQuestionnairePage/Layout"));
const AdminLayout = React.lazy(()=>import("../Screens/Admin/AdminLayout"))

const Router = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    const onUnauthorised = () => {
      localStorage.removeItem("token");
      dispatch(clearClientData(null));
      dispatch(clearUserDetails(null));
      navigate("/");
    };
    window.addEventListener("Unauth", onUnauthorised);
    // clean up event listener
    return () => {
      window.removeEventListener("Unauth", onUnauthorised);
    };
  }, []);
  return (
    <Routes>
      <Route path="/" element={<Home navigate={navigate} />} />
      <Route path="/Login" element={<Login navigate={navigate} />} />
      <Route path="/Verify" element={<Verify navigate={navigate}></Verify>} />
      <Route
        path="/Welcome"
        element={
          <PrivateRoute>
            <Welcome navigate={navigate} />
          </PrivateRoute>
        }
      />
      <Route
        path="/Register"
        element={
          <PrivateRoute>
            <Register navigate={navigate} />
          </PrivateRoute>
        }
      />
      <Route
        path="/servicerequest/*"
        element={
          <PrivateRoute>
            <Layout navigate={navigate} />
          </PrivateRoute>
        }
      />
      <Route
        path="/Admin/*"
        element={
          <Suspense fallback={<div></div>}>
          <AdminPrivateRoute>
            <AdminLayout navigate={navigate}></AdminLayout>
          </AdminPrivateRoute>
          </Suspense>
        }
      />
      <Route
        path="/cedargateadmin/*"
        element={
          <AdminPrivateRoute>
            <AdminLayout navigate={navigate}></AdminLayout>
          </AdminPrivateRoute>
        }
      />
      <Route
        path="/HUBExperience/*"
        element={
          <PrivateRoute>
            <Layout navigate={navigate}></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/ACGHealthInsights/*"
        element={
          <PrivateRoute>
            <Layout navigate={navigate}></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/clinicalIntake/*"
        element={
          <PrivateRoute>
            <Layout navigate={navigate}></Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/report/*"
        element={
          <PrivateRoute>
            <Layout navigate={navigate} />
          </PrivateRoute>
        }
      />
      <Route path="/signout" element={<Signout navigate={navigate} />} />
      <Route
        path="/EmpoweRx/*"
        element={
          <PrivateRoute>
            <Layout navigate={navigate} />
          </PrivateRoute>
        }
      />
      <Route
        path="/resource/*"
        element={
          <PrivateRoute>
            <Layout navigate={navigate} />
          </PrivateRoute>
        }
      />
      <Route
        path="/planinsights/*"
        element={
          <PrivateRoute>
            <Layout navigate={navigate} />
          </PrivateRoute>
        }
      />
      <Route
        path="/planinsightsadmin/*"
        element={
          <PrivateRoute>
            <Layout navigate={navigate} />
          </PrivateRoute>
        }
      />
      <Route path="/Questionnaire/*" element={
        <Suspense fallback={<div></div>}>
        <QuestionnaireLayout navigate={navigate} />
      </Suspense>
        } />
      <Route path="/notfound" element={<NotFoundPage />} />
      <Route
        path="/clinicalconsulting/*"
        element={
          <PrivateRoute>
            <Layout navigate={navigate} />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default Router;
